module.exports = __webpack_public_path__ + "img/4_6.6e2c400b.png";